import { Component, OnInit, ViewChild } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarOptions, DayCellMountArg } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import { calender } from '../../../../../models/leave.module';
import { AuthService } from '../../../../../services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LeaveService } from '../../../../../services/leave-holiday/leave.service';
import { AttendanceService } from '../../../../../services/attendance-service/attendance.service';
import { AttendanceDatas, AttendanceTotalData, Employee } from '../../../../../models/attendance.model';
import moment from 'moment';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { CommonService } from '../../../../../services/common/common.service';
import interactionPlugin from '@fullcalendar/interaction'
import { EmployeeListService } from '../../../../../services/employee/employee-list.service';
import { ToastService } from '../../../../../services/toast.service';
import { CompanyService } from '../../../../../services/company/company.service';

@Component({
  selector: 'app-attendance-grid',
  templateUrl: './attendance-grid.component.html',
  styleUrl: './attendance-grid.component.scss'
})
export class AttendanceGridComponent implements OnInit {
  constructor(private auth: AuthService, private modalService: NgbModal,
    private readonly leaveService: LeaveService, private attendanceService: AttendanceService,
    private companyService: CompanyService, private router: Router, private commonService: CommonService, private readonly employeeService: EmployeeListService, private toastService: ToastService
  ) { }

  date!: Date;
  companySettingDate: string = '';
  holidayList: calender[] = [];
  companyList: any[] = [];
  locationList: any[] = [];
  hideCompany: boolean = false;
  location_id: any = '';

  leaveDataList: any = [];
  weekends: any = [];
  totalLeave: any;

  minDate: string = '';
  maxDate: string = '';

  attendanceData: AttendanceDatas[] = [];
  weekOff: any;
  attendanceTotalData: AttendanceTotalData[] = [];
  employees: Employee[] = [];
  totalRecords: number = 0;
  currentPage: number = 0;
  loading: boolean = false;

  page = 0;
  pageSize = 10;
  numberofitems = 10;
  searchEmployees: string = '';
  filterCriteria: string = '';

  currentSortOrder: 'asc' | 'desc' = 'asc';
  currentSortField: any = '_id';

  weekendColour: any = '';
  publicHolidayColor: any = '';

  selectedDate!: any;
  paramsDate: any;
  currentDate: any;
  // currentdate!: string;
  selectedIndex = 0;
  angularDateFormat: any;
  showButton: boolean = false;

  joiningDate: any;
  employeeDetail: any;
  today: any;

  @ViewChild('calendar') calendarComponent: FullCalendarComponent | undefined;
  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin, interactionPlugin],
    initialView: 'dayGridMonth',
    headerToolbar: {
      left: 'prev',
      center: 'title',
      right: 'next'
    },
    datesSet: async (info) => {
      const calendarApi = this.calendarComponent?.getApi();
      const currentDate = calendarApi?.getDate();
      if (currentDate) {
        const month: any = currentDate.getMonth() + 1;
        const year: any = currentDate.getFullYear();
        await this.getAttendance(month, year);
      }
    },
    events: this.attendanceData,
    dateClick: this.onDateClick.bind(this), // Handle the dateClick event
    // eventClick: this.handleEventClick.bind(this),
    contentHeight: 'auto',
    dayHeaderContent: this.renderDayHeaderContent,
    dayCellContent: (dayCellInfo) => {
      const event = this.attendanceData.find(event => moment(event.attendancedate).format('YYYY-MM-DD') == moment(dayCellInfo.date).format('YYYY-MM-DD'));
      const checkInTime = event && event.checkintime ? moment(event.checkintime).utc().format('h:mm A') : '';
      const checkOutTime = event && event.checkouttime ? moment(event.checkouttime).utc().format('h:mm A') : '';
      const overTime = Number(event?.overtimehours);
      const weekEnd = this.weekOff?.includes(moment(dayCellInfo.date).format('dddd'));
      const root = document.documentElement;
      root.style.setProperty('--weekend-color', this.weekendColour);
      root.style.setProperty('--publicholiday-color', this.publicHolidayColor);
      let checkinStatus = checkInTime && checkOutTime ? true : false

      return {
        html: `
              ${`<div class="time-range">
                <p class="time">${checkInTime || checkOutTime ? `${checkInTime} - ${checkOutTime}` : ''}</p>
                <span class="date-number">${dayCellInfo?.dayNumberText}</span>
                </div>`}
              <div class="custom-day-cell">
                <p class="total_hour">${event?.totalhoursworked ? 'Total Hours' : ''}</p>
                ${event?.totalhoursworked ? `<div class="event-title">${event?.totalhoursworked}</div>` : ''}
              </div>
              <div class="status-cont">
                ${(checkInTime && checkOutTime !== '') ? `<p class="present_status status">P</p>` : ''}
                ${((event?.attendancedate) && (!checkinStatus)) && (event?.checkintime && !event?.checkouttime) ? `<p class="abbsent_status status">A</p>` : ''}
                ${(weekEnd && !checkinStatus) ? `<div class="weekend-day">
                  <p class="week_end status">W</p>
                </div>` : ""}
                ${(!weekEnd && !checkinStatus) && (!event?.checkintime) ? `<div class="weekend">
                  <p class="week_end status">L</p>
                </div>` : ""}
                <p class="checkin_status">${(event?.status) ? `${event?.status}` : ''}</p>
              </div>
            `,
      };
      // ${event?.status == 'Leave Approved' ? `<p class="leave_status">L</p>` : ''}
      // ${(!checkinStatus && !weekEnd) ? `<p class="leave_status">L</p>` : ''}
    },
    //   <div class="weekend" ${weekEnd === true}>
    //   <p>WeekEnd</p>
    // </div>
    dayCellClassNames: (arg) => {
      const event = this.weekOff?.includes(moment(arg.date).format('dddd'));
      const root = document.documentElement;
      root.style.setProperty('--weekend-day', this.weekendColour);
      root.style.setProperty('--public-holiday-day', this.publicHolidayColor);
      if (event === true) {
        return {
          html: `${`<p class="week_end">Weekend</p>`}`
        };
      }
      //  else if (event?.category === 'Leave') {
      //   return ['leave-day'];
      // } else if (event?.category === 'Public Holiday') {
      //   return ['public-holiday-day'];
      // }
      return [];
      // const event = this.attendanceData.find(event => moment(event.attendancedate).format('YYYY-MM-DD') == moment(arg.date).format('yyyy-MM-DD'));
      // return [];
    },
    firstDay: 1,
    dayCellDidMount: (info: DayCellMountArg) => {
      setTimeout(() => {
        const event: any = this.attendanceData.find(event => moment(event?.attendancedate).format('YYYY-MM-DD') == moment(info.date).format('yyyy-MM-DD'));
        if (event) {
          info.el.setAttribute('title', event?.status);
        }



        if (event?.status === 'Leave Approved') {
          // info.el.style.backgroundColor = event.leave_color;
          Array.from(info.el.querySelectorAll('*')).forEach(child => {
            (child as HTMLElement).style.color = event?.leave_type?.absence_label_color;  // or your chosen color
          });
        } else if (event?.status === 'Leave Approved') { }
      }, 1000);
    },
  } as CalendarOptions;

  // handleDateClick(arg: any) {
  //   alert('Date clicked: ' + arg.dateStr);
  // }

  handleEventClick(arg: any) {
    alert('Event clicked: ' + arg.event.title);
  }

  handleCellClick(arg: any) {
    alert('Cell clicked: ' + arg.dateStr);
  }



  onDateClick(info: any) {
    this.currentDate = info.date;
    this.paramsDate = moment(info.date).format('YYYY-MM-DD');
    this.selectedDate = []
    const selectedDate = moment(info.date).format('YYYY/MM/DD');
    const selectedDateStr = new Date(selectedDate);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    selectedDateStr.setHours(0, 0, 0, 0);

    this.joiningDate.setHours(0, 0, 0, 0);

    this.showButton =
      selectedDateStr.getTime() >= this.joiningDate.getTime() &&
      selectedDateStr.getTime() <= today.getTime();

    this.getSingleData(selectedDate)

    const offcanvasEl = document.getElementById('offcanvasTop');
    if (offcanvasEl && (window as any).bootstrap) {
      const bsOffcanvas = new (window as any).bootstrap.Offcanvas(offcanvasEl);
      bsOffcanvas.show();
    }

  }

  regularisationDatePass() {
    this.router.navigate([`/app/attendance/attendance-regularization/request/${this.paramsDate}`])
  }

  renderEventContent(eventInfo: any) {
    return {
      html: `
        <div style="text-align: center; font-size: 12px;">
          <div style="
            border-radius: 50%">
          </div>
          <div>${eventInfo.event.title}</div>
        </div>
      `,
    };
  }

  renderDayHeaderContent(dayHeaderInfo: any) {
    return {
      html: `<div style="padding-right: 50px;color: black;text-decoration:none;font-size: 12px;">${dayHeaderInfo.text}</div>`,
    };
  }

  renderDayCellContent(dayCellInfo: any) {
    const event = this.attendanceData.find(event =>
      moment(event.attendancedate).format('YYYY-MM-DD') === moment(dayCellInfo.date).format('YYYY-MM-DD')
    );
    const checkInTime = event ? moment(event.checkintime).utc().format('h:mm A') : '';
    const checkOutTime = event ? moment(event.checkouttime).utc().format('h:mm A') : '';

    // return {
    //   html: `<div style="color: black;text-decoration:none;font-size: 12px;">${dayCellInfo.dayNumberText}</div>`,
    // };

    return {
      html: `
        <div class="time-range">
          <p class="time">${checkInTime || checkInTime ? `${checkInTime} - ${checkOutTime}` : ''}</p>
          <span class="date-number">${dayCellInfo.dayNumberText}</span>
        </div>
        <div class="custom-day-cell">
          <p class="total_hour">${event?.totalhoursworked ? 'Total Hours' : ''}</p>
          ${event?.totalhoursworked ? `<div class="event-title">${event?.totalhoursworked}</div>` : ''}
        </div>
      `,
    };
  }

  list(currentYear: any, currentMonth: any) { }

  async getAttendance(month: string, year: any) {
    let params = {
      month: month, year: year
    }


    this.attendanceService.getEmployeesMonth(params).subscribe({
      next: (data) => {
        this.attendanceData = data.data.data;

        this.weekOff = data.data?.weekoff;
        this.weekendColour = data.data?.weekendColour
        this.publicHolidayColor = data.data?.publicHolidayColor
        // this.employees = this.attendanceData.map(item => {
        //   const { employee, ...attendanceData } = item;
        //   return { ...attendanceData, ...employee };
        // });
        this.totalRecords = data.data.totalItems;
        this.currentPage = data.data.currentPage;
        this.calendarOptions.events = data.data.data;

        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }

  removeValue() {
    this.modalService.dismissAll();
    // this.formData.reset();
  }
  checkPermission(type: string) {
    return this.auth.checkPermission(type);
  }



  async ngOnInit() {
    const data: any = this.commonService.getLocalStorageData();
    await this.getEmployee(data?.userID);
    this.today = new Date();
    this.joiningDate = new Date(this.employeeDetail.dateofjoin)

    if (data) {
      this.companyService.getParametersById(data.companyID).subscribe({
        next: (resp) => {
          this.companySettingDate = resp?.data?.date_format;
          this.angularDateFormat = this.commonService.convertPrimeNGToAngularFormat(this.companySettingDate);

          const currentDate = new Date();
          this.date = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

          const currentYear: any = currentDate.getFullYear();
          const currentMonth: any = currentDate.getMonth() + 1;

          const previousYear = currentYear - 1;
          const nextYear = currentYear + 1;

          const minDate = new Date(previousYear, 0, 1);
          this.minDate = minDate.toISOString().split('T')[0];

          const maxDate = new Date(nextYear, 11, 31);
          this.maxDate = maxDate.toISOString().split('T')[0];

          this.list(currentYear, currentMonth);
          this.currentDate = currentDate;
          this.selectDate(currentDate);
        },
        error: (err) => {
          console.error('Error fetching company setting format:', err);
        }
      });
    }
  }

  async getEmployee(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.employeeService.getEmployeeView(id).subscribe({
        next: (resp) => {
          this.employeeDetail = resp.datas;
          
          resolve(resp.data);
        },
        error: (err) => {
          this.toastService.failure(err.message);
          reject(err);
        }
      });
    });
  }

  goToBack() {
    // this.location.back();
    this.router.navigate(['/app/attendance/list-view']);
  }

  changeCalendar(event: any) {
    const selectedDate = new Date(event);
    const selectedMonth: any = selectedDate.getMonth() + 1; // The month is 0-indexed (Jan = 0, Dec = 11)
    const selectedYear: any = selectedDate.getFullYear();

    // this.calendarOptions.initialDate = moment(`${selectedMonth}-${selectedYear + 1}-01`).toDate();
    // this.calendarComponent?.getApi().gotoDate(this.calendarOptions.initialDate);
    const newDate = moment(`${selectedYear}-${selectedMonth}-01`).toDate();
    this.calendarComponent?.getApi().gotoDate(newDate);
    this.getAttendance(selectedMonth, selectedYear);
  }

  selectDate(event: any) {
    const day = String(event.getDate()).padStart(2, '0');
    const month = String(event.getMonth() + 1).padStart(2, '0');
    const year = event.getFullYear();
    const formattedDate = `${year}/${month}/${day}`;
    const formatedParamDate = `${year}-${month}-${day}`
    this.paramsDate = formatedParamDate;

    const selectedDate = new Date(`${year}-${month}-${day}`);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    this.showButton = selectedDate.getTime() <= today.getTime();

    this.getSingleData(formattedDate)
  }

  getSingleData(formattedDate: any) {
    this.attendanceService.getPunchStatus(formattedDate).subscribe({
      next: (res) => {
        this.selectedDate = res?.data;
      }
    });
  }
}